export const countryList = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas (the)',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia (Plurinational State of)',
  'Bonaire, Sint Eustatius and Saba',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory (the)',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cabo Verde',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cayman Islands (the)',
  'Central African Republic (the)',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands (the)',
  'Colombia',
  'Comoros (the)',
  'Congo (the Democratic Republic of the)',
  'Congo (the)',
  'Cook Islands (the)',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Curaçao',
  'Cyprus',
  'Czechia',
  "Côte d'Ivoire",
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic (the)',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Eswatini',
  'Ethiopia',
  'Falkland Islands (the) [Malvinas]',
  'Faroe Islands (the)',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories (the)',
  'Gabon',
  'Gambia (the)',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See (the)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran (Islamic Republic of)',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  "Korea (the Democratic People's Republic of)",
  'Korea (the Republic of)',
  'Kuwait',
  'Kyrgyzstan',
  "Lao People's Democratic Republic (the)",
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands (the)',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia (Federated States of)',
  'Moldova (the Republic of)',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands (the)',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger (the)',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands (the)',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestine, State of',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines (the)',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Republic of North Macedonia',
  'Romania',
  'Russian Federation (the)',
  'Rwanda',
  'Réunion',
  'Saint Barthélemy',
  'Saint Helena, Ascension and Tristan da Cunha',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin (French part)',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Sint Maarten (Dutch part)',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan (the)',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands (the)',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates (the)',
  'United Kingdom of Great Britain and Northern Ireland (the)',
  'United States Minor Outlying Islands (the)',
  'United States of America (the)',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela (Bolivarian Republic of)',
  'Viet Nam',
  'Virgin Islands (British)',
  'Virgin Islands (U.S.)',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe',
  'Åland Islands',
];

export const EUCountryList = [
  'Austria',
  'Belgium',
  'Bulgaria',
  'Croatia',
  'Cyprus',
  'Czechia',
  'Denmark',
  'Estonia',
  'Finland',
  'France',
  'Germany',
  'Greece',
  'Hungary',
  'Ireland',
  'Italy',
  'Latvia',
  'Lithuania',
  'Luxembourg',
  'Malta',
  'Netherlands',
  'Poland',
  'Portugal',
  'Romania',
  'Slovakia',
  'Slovenia',
  'Spain',
  'Sweden',
  'Ukraine',
  'United Kingdom of Great Britain and Northern Ireland (the)',
];

export const applicationTypeOptions = ['Home', 'EU/EEA', 'International'];

export const userTitles = ['Mr', 'Miss', 'Ms', 'Mrs'];

export const qualificationLevels = [
  'Secondary School',
  'Higher Secondary School',
  'Diploma',
  'Higher National Diploma (HND)',
  'Higher National Certificate (HNC)',
  'Pre-sessional English',
  'Foundation programme',
  'International Year One',
  'Undergraduate: BA, BSc, MEng, and BEng',
  'Pre-Masters programme',
  'Postgraduate degrees: MA, MSc, MBA, MSci, MEng',
  'Research degrees: Phd',
  'Level 3',
  'Level 4',
  'Level 5',
  'Pathway Program',
  'Professional Course',
  'MEng',
  'Short Course',
];

export const englishTest = [
  'IELTS',
  'TOEFL',
  'GCSE',
  'PEARSON',
  'Functional Skill',
  'Duolingo',
  'Others',
];

export const docType = [
  'Ask33 Consent Form',
  'Checklist',
  'Transcript',
  'Diploma+Transcript',
  'Personal Statement',
  'Share Code',
  'Proof of Address',
  'Non standard route document',
  'Certificate',
  'English test score',
  'Photograph',
  'SFE Pre-Application Screenshot',
  'Passport',
  'CV',
  'Profile picture',
  'Other',
];

export const euSettlementStatus = [
  'Settled',
  'Pre-Settled',
  'British Passport',
  'Irish Passport',
];

export const employmentStatus = ['Employed', 'Unemployed', 'Self-Employed'];

export const financeStatuses = [
  'Draft',
  'Awaiting review',
  'Info required',
  'Approved',
  'Rejected',
  'Application submitted',
  'None',
  'All',
];

export const paymentStatuses = [
  'Paid',
  'Approved',
  'Rejected',
  'Info required',
  'None',
  'All',
  'Needs review',
];

export const statusOptionsClasses = {
  Submitted: 'status-submitted',
  'Info required': 'status-info-required',
  // 'Defferal requested': 'status-deferral-requested',
  Deferred: 'status-deferred',
  Enrolled: 'status-enrolled',
  Rejected: 'status-danger',
  Pending: 'status-case-pending',
  // 'Case settled': 'status-case-settled',
  'Existing student': 'status-existing',
  'Not interested': 'status-not-interested',
  Booked: 'status-booked',
  // 'Under review': 'status-under-review',
  'Awaiting Uncon': 'status-await-unconditional',
  Unconditional: 'status-success',
};

export const studentMessageMapClass = {
  pending: '#F9B040',
  unresolved: '#f14668',
  'awaiting-manager': '#CB6CE6',
};

export const studentMessageStatusMap = [
  {
    id: null,
    value: 'No Status',
    color: '#a3a3a3',
    advisor: {
      nextAction: 'awaiting-manager',
      color: '#A383E4',
    },
    manager: {
      nextAction: 'unresolved',
      color: '#f14668',
    },
  },
  {
    id: 'pending',
    value: 'Awaiting Admin',
    color: '#F9B040',
    advisor: {
      nextAction: 'pending',
      color: null,
    },
    manager: {
      nextAction: null,
      color: '#10C66E',
    },
  },
  {
    id: 'unresolved',
    value: 'Awaiting Agent',
    color: '#f14668',
    advisor: {
      nextAction: 'pending',
      color: '#F9B040',
    },
    manager: {
      nextAction: null,
      color: '#10C66E',
    },
  },
  {
    id: 'awaiting-manager',
    value: 'Awaiting Admin',
    color: '#A383E4',
    advisor: {
      nextAction: null,
      color: '#10C66E',
    },
    manager: {
      nextAction: null,
      color: '#10C66E',
    },
  },
];

export const passingOptionsClasses = {
  Resit: 'status-yellow-booking',
  Undecided: 'status-yellow-booking',
  'Resit writing': 'status-yellow-booking',
  'Resit reading': 'status-yellow-booking',
  'No show': 'status-yellow-booking',
  Exempt: 'status-success',
  Pass: 'status-success',
  Fail: 'status-danger',
};

export const statusOptions = Object.keys(statusOptionsClasses);

export const passingOptions = Object.keys(passingOptionsClasses);

export const genderOptions = [
  'Female',
  'Male',
  'Prefer not to say',
  'Non binary',
  'Transgender',
];

export const studentFinance = [
  'Applied',
  'Initial commission received',
  'Final commission received',
];

export const deadlineInvalidDates = [
  'tbd',
  'n/a',
  ' ',
  'open',
  'to be confirmed',
  'closed',
];
export const deadlineCoursesDates = [
  'tbd',
  'n/a',
  ' ',
  'open',
  'to be confirmed',
];

export const referalLocations = [
  'Recommendations',
  'Facebook',
  'Instagram',
  'Tik Tok',
  'Other (explain)',
];

export const deliveryModes = [
  'Weekday',
  'Weekend',
  'Evening',
  'Weekday - Blended',
  'Weekend - Blended',
  'Evening-Blended',
];

export const intakes = [
  'September/October/November 2024',
  'January/February 2024',
  'April/May/June 2024',
  'January/February 2023',
  'April/May/June 2023',
  'September/October/November 2023',
  'January/February 2025',
  'April/May/June 2025',
];

export const maritalStatus = [
  'Single',
  'Living with a partner',
  'Married',
  'Separated',
  'Divorced',
  'Widowed',
];

export const datesWithMoment = [
  {
    text: `January ${new Date().getFullYear()}`,
    month: 0,
    year: new Date().getFullYear(),
  },
  {
    text: `February ${new Date().getFullYear()}`,
    month: 1,
    year: new Date().getFullYear(),
  },
  {
    text: `March ${new Date().getFullYear()}`,
    month: 2,
    year: new Date().getFullYear(),
  },
  {
    text: `April ${new Date().getFullYear()}`,
    month: 3,
    year: new Date().getFullYear(),
  },
  {
    text: `May ${new Date().getFullYear()}`,
    month: 4,
    year: new Date().getFullYear(),
  },
  {
    text: `June ${new Date().getFullYear()}`,
    month: 5,
    year: new Date().getFullYear(),
  },
  {
    text: `July ${new Date().getFullYear()}`,
    month: 6,
    year: new Date().getFullYear(),
  },
  {
    text: `August ${new Date().getFullYear()}`,
    month: 7,
    year: new Date().getFullYear(),
  },
  {
    text: `September ${new Date().getFullYear()}`,
    month: 8,
    year: new Date().getFullYear(),
  },
  {
    text: `October ${new Date().getFullYear()}`,
    month: 9,
    year: new Date().getFullYear(),
  },
  {
    text: `November ${new Date().getFullYear()}`,
    month: 10,
    year: new Date().getFullYear(),
  },
  {
    text: `December ${new Date().getFullYear()}`,
    month: 11,
    year: new Date().getFullYear(),
  },
];

export const userIconSvg =
  'data:image/png;base64,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';
